import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  badge: {
    marginLeft: 17,
    marginTop: -17,
  },
}));

export default useStyles;
